import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from 'src/app/core/guards/role.guard';
import { UserResolver } from 'src/app/core/resolves/user.resolve';
import { UserActiveGuard } from 'src/app/core/guards/user-active.guard';
import { MainComponent } from 'src/app/layout/main/main.component';

/**
 * Routing module for satellite lock module
 * Routes will be added when components are created
 */
const routes: Routes = [
    {
        path: 'satellite-lock',
        component: MainComponent,
        data: { breadcrumb: 'Candados Satelitales' },
        children: [
            // Routes will be added here when components are created
            // Example:
            // {
            //   path: 'list',
            //   data: { breadcrumb: 'Listado' },
            //   component: SatelliteLockListComponent,
            //   canActivate: [UserActiveGuard, RoleGuard],
            //   resolve: {
            //     UserResolver
            //   }
            // },
            { path: '**', redirectTo: '/home' }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class SatelliteLockRoutingModule { }

